export const AUTH_SESSION = 'AUTH_SESSION';
export const LOGOUT = 'LOGOUT';